(() => {
  if (window.ugProductFit) { window.ugProductFit.scan(); return; }
  const selector = '#MainContent .card__media .media > img,#MainContent .ugx-media > img.ugx-img,#MainContent .ug-media > img.ug-image,#MainContent .ugx-tile-visual > img.ugx-tile-img,#MainContent .ugc-model-image img,#MainContent .product__media img,.predictive-search__image,.cart-item__image,.cart-notification-product__image img,.ug-colors__item img,.ugb-thumb img,.ugb-peek img,.quick-add__product-container img,.thumbnail img';
  // Theme-only replacements keep the original product media available for rollback.
  const imageReplacements = {"ug-level-15385367019752.png": "ug-drift-triple-white-bg-1-20261025.png", "ug-sale-drift-white-1.png": "ug-drift-triple-white-bg-2-20261025.png", "ug-sale-drift-white-2.png": "ug-drift-triple-white-bg-3-20261025.png", "ug-sale-drift-white-3.png": "ug-drift-triple-white-bg-4-20261025.png", "ug-sale-drift-white-4.png": "ug-drift-triple-white-bg-5-20261025.png", "mcqueen-white-blue-prikaz-2.jpg": "ug-white-bg-46683055980776-20261025.png", "mcqueen-white-blue-prikaz-3.jpg": "ug-white-bg-46683056111848-20261025.png", "mcqueen-white-blue-prikaz-4.jpg": "ug-white-bg-46683056668904-20261025.png", "nike-shox-tl-metallic-platinum-pink-foam-2.png": "ug-white-bg-46683608154344-20261025.png", "nike-shox-tl-metallic-platinum-pink-foam-3.png": "ug-white-bg-46683608252648-20261025.png", "nike-shox-tl-metallic-platinum-pink-foam-4.png": "ug-white-bg-46683608350952-20261025.png", "nike-shox-tl-metallic-platinum-pink-foam-5.png": "ug-white-bg-46683608482024-20261025.png"};
  function imageBlendMode(image) {
    return image.closest('#MainContent .card-wrapper:has(.price--ug-sale),#MainContent .ugx-card:has(.ugx-price--sale),#MainContent ug-sale-drop .ug-card') ? 'normal' : 'multiply';
  }
  function replaceImageSources(root = document) {
    const images = root.matches?.('img,source') ? [root] : root.querySelectorAll('img,source');
    images.forEach(image => {
      for (const attribute of ['src','srcset','data-src','data-srcset']) {
        const original = image.getAttribute(attribute);
        if (!original) continue;
        let updated = original;
        for (const [before, after] of Object.entries(imageReplacements)) updated = updated.split(before).join(after);
        if (updated !== original) image.setAttribute(attribute, updated);
      }
      if (image.matches('img') && Object.values(imageReplacements).some(filename => (image.getAttribute('src') || '').includes(filename))) image.style.setProperty('mix-blend-mode',imageBlendMode(image),'important');
    });
  }
  const cache = new Map();
  const observed = new WeakSet();
  const frameImages = new WeakMap();
  let scheduled = false;
  function sourceOf(image) {
    const source = image.hasAttribute('srcset') ? (image.currentSrc || image.src) : image.src;
    return /^(data:|blob:)/.test(source) && image.dataset.ugOriginalImage ? image.dataset.ugOriginalImage : source;
  }
  function measure(source) {
    const canvas = document.createElement('canvas');
    const factor = Math.min(1, 480/source.naturalWidth, 480/source.naturalHeight);
    const width=canvas.width=Math.max(1,Math.round(source.naturalWidth*factor));
    const height=canvas.height=Math.max(1,Math.round(source.naturalHeight*factor));
    const context=canvas.getContext('2d',{willReadFrequently:true});
    context.drawImage(source,0,0,width,height);
    const data=context.getImageData(0,0,width,height),pixels=data.data;
    const corners=[0,width-1,(height-1)*width,width*height-1];
    const opaque=corners.every(p=>pixels[p*4+3]>240);
    const bg=[0,1,2].map(c=>corners.reduce((s,p)=>s+pixels[p*4+c],0)/4);
    const flat=opaque&&Math.min(...bg)>195&&Math.max(...bg)-Math.min(...bg)<18&&corners.every(p=>[0,1,2].every(c=>Math.abs(pixels[p*4+c]-bg[c])<14));
    if(flat){
      const visited=new Uint8Array(width*height),queue=new Int32Array(width*height);let head=0,tail=0;
      const add=p=>{
        if(visited[p])return;visited[p]=1;
        const i=p*4;
        if(Math.max(...[0,1,2].map(c=>Math.abs(pixels[i+c]-bg[c])))<=18)queue[tail++]=p;
      };
      for(let x=0;x<width;x++){add(x);add((height-1)*width+x);}
      for(let y=0;y<height;y++){add(y*width);add(y*width+width-1);}
      while(head<tail){const p=queue[head++],x=p%width,y=Math.floor(p/width);
        pixels[p*4+3]=0;
        if(x) add(p-1);if(x<width-1)add(p+1);if(y)add(p-width);if(y<height-1)add(p+width);
      }

    }
    const mask=new Uint8Array(width*height),queue=new Int32Array(width*height);
    for(let p=0;p<mask.length;p++){
      const i=p*4;if(pixels[i+3]<80)continue;
      const low=Math.min(pixels[i],pixels[i+1],pixels[i+2]),high=Math.max(pixels[i],pixels[i+1],pixels[i+2]);
      if(!flat&&opaque&&low>238&&high-low<10)continue;
      mask[p]=1;
    }
    const components=[];let largest=0;
    for(let start=0;start<mask.length;start++){
      if(mask[start]!==1)continue;
      let head=0,tail=1,l=width,r=-1,t=height,b=-1;queue[0]=start;mask[start]=2;
      while(head<tail){const p=queue[head++],x=p%width,y=Math.floor(p/width);l=Math.min(l,x);r=Math.max(r,x);t=Math.min(t,y);b=Math.max(b,y);
        for(let dy=-1;dy<=1;dy++)for(let dx=-1;dx<=1;dx++){const nx=x+dx,ny=y+dy;if(nx<0||ny<0||nx>=width||ny>=height)continue;const n=ny*width+nx;if(mask[n]===1){mask[n]=2;queue[tail++]=n;}}
      }
      components.push({l,r,t,b,count:tail});largest=Math.max(largest,tail);
    }
    let left=width,right=-1,top=height,bottom=-1;
    for(const c of components){if(c.count<Math.max(8,largest*.0005))continue;left=Math.min(left,c.l);right=Math.max(right,c.r);top=Math.min(top,c.t);bottom=Math.max(bottom,c.b);}
    const margin=Math.ceil(Math.max(width,height)*0.025);
    left=Math.max(0,left-margin);right=Math.min(width-1,right+margin);top=Math.max(0,top-margin);bottom=Math.min(height-1,bottom+margin);
    if(right<=left||bottom<=top)return null;
    return {w:(right-left+1)/width,h:(bottom-top+1)/height,x:(left+right+1)/(2*width),y:(top+bottom+1)/(2*height),ratio:width/height};
  }
  let workerTask;
  let sequence = 0;
  let queue = Promise.resolve();
  const jobs = new Map();
  async function getWorker() {
    if (!window.Worker || !window.OffscreenCanvas || !window.createImageBitmap) return null;
    if (!workerTask) workerTask = (async () => {
      const src = document.documentElement.dataset.ugFitWorker;
      if (!src) return null;
      const response = await fetch(src, {cache:'force-cache'});
      if (!response.ok) throw new Error('Image worker unavailable');
      const url = URL.createObjectURL(new Blob([await response.text()], {type:'text/javascript'}));
      const worker = new Worker(url);
      URL.revokeObjectURL(url);
      worker.onmessage = ({data}) => {
        const job = jobs.get(data.id);
        if (!job) return;
        jobs.delete(data.id);
        clearTimeout(job.timer);
        if (data.error) job.reject(new Error(data.error));
        else {
          const box = data.result;
          if (box?.blob) { box.cutout = URL.createObjectURL(box.blob); delete box.blob; }
          job.resolve(box);
        }
      };
      worker.onerror = () => {
        jobs.forEach(job => { clearTimeout(job.timer); job.reject(new Error('Image worker unavailable')); });
        jobs.clear();
        worker.terminate();
        workerTask = Promise.resolve(null);
      };
      return worker;
    })().catch(() => null);
    return workerTask;
  }
  async function processImage(source) {
    const worker = await getWorker();
    if (worker) {
      try {
        const bitmap = await createImageBitmap(source);
        return await new Promise((resolve,reject) => {
          const id = ++sequence;
          const timer = setTimeout(() => { jobs.delete(id); reject(new Error('Image worker timeout')); },15000);
          jobs.set(id,{resolve,reject,timer});
          worker.postMessage({id,image:bitmap},[bitmap]);
        });
      } catch (error) {}
    }
    await new Promise(resolve => {
      if (window.requestIdleCallback) requestIdleCallback(resolve, {timeout:1500});
      else setTimeout(resolve, 32);
    });
    return measure(source);
  }
  function bounds(url) {
    if (cache.has(url)) return cache.get(url);
    const task = queue.then(() => new Promise((resolve, reject) => {
      const source = new Image();
      source.crossOrigin = 'anonymous';
      source.onload = () => processImage(source).then(resolve,reject);
      source.onerror = () => reject(new Error('Product image unavailable'));
      source.src = url;
    }));
    queue = task.catch(() => {});
    cache.set(url, task);
    task.catch(() => cache.delete(url));
    if (cache.size > 120) cache.delete(cache.keys().next().value);
    return task;
  }
  function imageWidthForBox(box, width, height) { return Math.min(width, height * box.ratio); }
  function placement(box, width, height, isTile) {
    const imageWidth = Math.min(width, height * box.ratio);
    const imageHeight = imageWidth / box.ratio;
    const scale = Math.min(width * (isTile ? 0.92 : 0.92) / (imageWidth * box.w),
      height * (isTile ? 0.92 : 0.92) / (imageHeight * box.h));
    const dx = (0.5 - box.x) * imageWidth * scale;
    const dy = (0.5 - box.y) * imageHeight * scale;
    return { scale, dx, dy };
  }
  const processing = new WeakMap();
  const fittedSources = new WeakMap();
  function reset(image) {
    if (!image) return;
    fittedSources.delete(image);
    for (const property of ['--ug-product-fit','--ugc-image-transform','--ug-image-transform']) image.style.removeProperty(property);
    image.style.setProperty('transform', 'scale(0.92)', 'important');
    for (const [property, value] of Object.entries({width:'100%',height:'100%',padding:'0px','max-width':'none','max-height':'none','object-fit':'contain','object-position':'center','transform-origin':'center'})) image.style.setProperty(property, value, 'important');
    delete image.dataset.ugFitted;
    delete image.dataset.ugSubjectWidth;
    delete image.dataset.ugFitVersion;
  }
  async function fit(image) {
    if (!image || !image.isConnected) return;
    const url = sourceOf(image);
    if (!url) return;
    const pending = processing.get(image);
    if (pending?.url === url) return pending.promise;
    if (fittedSources.get(image) !== url) reset(image);
    if (!image.complete || !image.naturalWidth) return;
    const position = image.parentElement.getBoundingClientRect();
    if (!position.width || position.bottom < -300 || position.top > innerHeight + 300) { visible.observe(image); return; }
    const job = {url, promise: null};
    processing.set(image, job);
    job.promise = applyFit(image, url, job);
    return job.promise;
  }
  async function applyFit(image, url, job) {
    try {
      const box = await bounds(url);
      if (!box || !image.isConnected || sourceOf(image) !== url || processing.get(image) !== job) return;
      image.dataset.ugUnifiedFit = 'true';
      const frame = image.parentElement, width = frame.clientWidth, height = frame.clientHeight;
      if (!width || !height) return;
      const result = placement(box, width, height, false);
      const transform = 'translate(' + result.dx.toFixed(3) + 'px,' + result.dy.toFixed(3) + 'px) scale(' + result.scale.toFixed(6) + ')';
      image.style.setProperty('--ug-product-fit', transform);
      image.style.setProperty('--ugc-image-transform', transform);
      image.style.setProperty('--ug-image-transform', transform);
      image.style.setProperty('transform', transform, 'important');
      for (const [property, value] of Object.entries({width:'100%',height:'100%',padding:'0px','max-width':'none','max-height':'none','object-fit':'contain','object-position':'center','transform-origin':'center','mix-blend-mode':imageBlendMode(image)})) image.style.setProperty(property, value, 'important');
      image.dataset.ugFitted = 'true';
      image.dataset.ugFitVersion = '10';
      image.dataset.ugSubjectWidth = (imageWidthForBox(box, width, height) * box.w * result.scale / width).toFixed(4);
      fittedSources.set(image, url);
    } catch (error) {
      if (sourceOf(image) === url && processing.get(image) === job) { reset(image); image.dataset.ugFitted = 'fallback'; }
    } finally {
      if (processing.get(image) === job) processing.delete(image);
    }
  }
  const resize = new ResizeObserver(entries => entries.forEach(entry => {
    const images = frameImages.get(entry.target);
    if (images) images.forEach(image => { if (image.isConnected) fit(image); else images.delete(image); });
  }));
  const visible = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { fit(entry.target); visible.unobserve(entry.target); }
  }), {rootMargin:'300px'});
  function scan() {
    replaceImageSources();
    document.querySelectorAll(selector).forEach(image => {
      if (observed.has(image)) return;
      observed.add(image);
      image.dataset.ugUnifiedFit = 'true';
      image.addEventListener('load', () => fit(image));
      const frame = image.parentElement;
      if (!frameImages.has(frame)) { frameImages.set(frame, new Set()); resize.observe(frame); }
      frameImages.get(frame).add(image);
      visible.observe(image);
      if (image.complete) { const r=image.getBoundingClientRect(); if(r.bottom>=-300&&r.top<=innerHeight+300) fit(image); }
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scan(); });
  }
  function start() {
    scan();
    const root = document.body;
    if (root) new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') {
          replaceImageSources(record.target);
          if (record.target.matches(selector)) fit(record.target);
        }
      }
      if (records.some(record => record.type === 'childList')) schedule();
    }).observe(root, {childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset']});
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
  }
  window.ugProductFit = {scan:schedule,fit,reset};
  document.dispatchEvent(new Event('ug:product-fit-ready'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();




